import styled from '@emotion/styled';
import React, { useState, useEffect } from 'react';
import { useGlobalEvent } from 'beautiful-react-hooks';

import Modal from '~/App/Components/Modal';
import CloseIcon from '~/Share/components/Atoms/CloseIcon';
import { theme } from '@vimily/bonjoro-ui-components';

const StyledCloseIcon = styled(CloseIcon)`
  font-size: 30px;
  font-weight: bold;
  right: 30px;
  top: 30px;
  color: #222222;
`;

export const openUpgradeModal = (upgradeModalUid: string) => {
  window.dispatchEvent(new Event(`${upgradeModalUid}::open`));
};
export interface BaseUpgradeModalProps {
  openEvent: string;
  closeEvent?: string;
  backgroundColor?: string;
  maxWidth?: number | string;
  padding?: number | string;
  centered?: boolean;
  children: React.ReactNode;
  onOpen?(): void;
}

const BaseUpgradeModal = ({
  openEvent,
  closeEvent = 'base-upgrade-modal::close',
  backgroundColor = theme.colors.white,
  maxWidth = 1045,
  padding = 30,
  centered = false,
  children,
  onOpen,
}: BaseUpgradeModalProps) => {
  const [isOpen, setOpen] = useState(false);

  const onRequestOpen = useGlobalEvent(openEvent as keyof WindowEventMap);

  const onRequestClose = useGlobalEvent(closeEvent as keyof WindowEventMap);

  const handleCloseModal = () => setOpen(false);

  onRequestOpen(() => setOpen(true));
  onRequestClose(handleCloseModal);

  useEffect(() => {
    isOpen && onOpen?.();
  }, [isOpen]);

  const modalProps = {
    styles: {
      overlay: ({ base }) => ({
        ...base,
        width: '100%',
        padding: 30,
        display: centered ? 'flex' : 'block',
      }),
      content: ({ base }) => ({
        ...base,
        maxWidth,
        width: '100%',
        padding: 'unset',
        margin: 'auto',
      }),
      panel: ({ base }) => ({
        ...base,
        width: '100%',
        height: 'auto',
        position: 'relative',
        border: 'unset',
        overflow: 'hidden',
        borderRadius: 5,
        backgroundColor,
        padding,
        marginBottom: 0,
      }),
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      hideActions
      {...modalProps}
    >
      <StyledCloseIcon onClick={handleCloseModal} />
      {children}
    </Modal>
  );
};

export default BaseUpgradeModal;
